import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { gql } from "@urql/core";
import { useQuery } from "urql";
import { useMutation } from "urql";
import { cleanText } from "../utils/cleanString";

const mutate = gql`
  mutation MyMutation($object: cms_career_registrations_insert_input!) {
    insert_cms_career_registrations_one(object: $object) {
      id
    }
  }
`;

const query = gql`
  query MyQuery {
    cms_careers(where: { is_open: { _eq: true } }) {
      id
      title
      benefits
      description
      requirements
      is_open
    }
  }
`;

const initialForm = {
  full_name: "",
  phone: "",
  email: "",
  date_of_birth: "",
  gender: 0,
  education: "",
  university: "",
  major: "",
  gpa: "",
  graduation_year: "",
  link: "",
  file: null,
  cover_letter: "",
  cms_career_id: 0,
  cms_career_registration_status_id: 1,
};

export default function useKarir() {
  const [data, setData] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [value, setValue] = useState("");

  const handleChangeEditor = (content) => {
    setValue(content);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const [{ data: tempData, fetching }] = useQuery({ query: query });
  const [{ fetching: submitForm }, handlePost] = useMutation(mutate);

  const handleLinkFile = async (pdf) => {
    try {
      const form = new FormData();
      form.append("filename", cleanText(pdf.name));
      const s3 = await fetch("/api/v1/admin/S3", {
        method: "PUT",
        body: form,
        headers: {
          "API-KEY": process.env.NEXT_PUBLIC_SSO_API_KEY,
        },
      });
      const { data } = await s3.json();
      await fetch(data, {
        method: "PUT",
        body: pdf,
      });
      return data;
    } catch (err) {
      console.log({ err });
    }
  };

  const handleSubmit = async (e, form, value) => {
    try {
      e.preventDefault();
      let final_pdf = form.file;
      if (typeof final_pdf !== "string") {
        final_pdf = await handleLinkFile(final_pdf);
      }

      let final_post = { ...form, file: final_pdf, cover_letter: value };
      const job = data.filter((e) => e.id == form.cms_career_id)[0].title;

      const finalBody = {
        recipients: ["sekretariat@wardayacollege.com"],
        subject: `${job} Candidate - ${form.full_name}`,
        body: `${value} \n CV : ${final_pdf}`,
      };
      const req = await fetch(
        process.env.NEXT_PUBLIC_API + `/api/v1/admin/email`,
        {
          method: "POST",
          body: JSON.stringify(finalBody),
          headers: {
            "API-KEY": process.env.NEXT_PUBLIC_SSO_API_KEY,
          },
        }
      );
      const { error: errorSendToAdmin, status } = await req.json();

      if (status !== "success") {
        throw new Error(errorSendToAdmin);
      }

      const { error: postError } = await handlePost({
        object: {
          ...final_post,
          created_at: new Date(),
        },
      });

      if (postError) {
        throw new Error(postError.message);
      }

      setForm({ ...initialForm, file: null });
      setValue("");
      toast.success("Anda berhasil mendaftar pekerjaan di Wardaya College");
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (tempData) {
      const temps = [];
      for (const item of tempData.cms_careers) {
        temps.push({
          id: item.id,
          title: item.title,
          benefits: item.benefits,
          description: item.description,
          requirements: item.requirements,
          is_open: item.is_open,
        });
      }
      setData(temps);
    }
  }, [tempData]);

  return {
    data,
    fetching,
    value,
    form,
    setForm,
    handleChange,
    handleChangeEditor,
    submitForm,
    handleSubmit,
  };
}
